/** Manages moving tasks within the hierarchy and re-exports rebalancing. */
// @ts-check
import { useCallback } from 'react';
import useTaskQueries from '@/features/tasks/api/use-task-queries';
import { useTaskRebalance } from '@/features/tasks/hooks/mutations/use-task-rebalance';
import { executeMoveTask } from '@/features/tasks/utils/mutations/taskStructureMovementUtils';

const useTaskStructure = () => {
  const { fetchTaskById } = useTaskQueries();
  const { rebalanceOrderKeys } = useTaskRebalance();

  /**
   * @param {string} taskId
   * @param {Object} params
   * @param {string} userId
   * @param {Task | null} [existingTask]
   */
  const moveTask = useCallback(
    async (taskId, params, userId, existingTask = null) => {
      if (!taskId) {
        console.error('MOVE_TASK ERROR: No taskId provided.');
        return;
      }
      if (!userId) {
        console.error('MOVE_TASK ERROR: No userId provided.');
        return;
      }

      try {
        const result = await executeMoveTask(
          taskId,
          params,
          userId,
          fetchTaskById,
          existingTask,
        );
        if (result === null) {
          console.error('[moveTask] ERROR: Task to move does not exist.');
        }
      } catch (e) {
        console.error('MOVE_TASK ERROR:', e);
        throw e;
      }
    },
    [fetchTaskById],
  );

  return { moveTask, rebalanceOrderKeys };
};

export default useTaskStructure;
